import clsx from 'clsx';
import type { ReactNode } from 'react';
import { Icon, type IconName } from '../Icon/Icon';
import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  icon: IconName;
  title: ReactNode;
  children?: ReactNode;
  /** Action buttons. */
  actions?: ReactNode;
  /** `dashed` (default, `.empty`) or `card` (white panel, `.gate`). */
  look?: 'dashed' | 'card';
  compact?: boolean;
  className?: string;
}

export function EmptyState({ icon, title, children, actions, look = 'dashed', compact, className }: EmptyStateProps) {
  return (
    <div className={clsx(styles.root, styles[look], compact && styles.compact, className)}>
      <span className={styles.icon}>
        <Icon name={icon} size={28} strokeWidth={1.9} />
      </span>
      <b className={clsx('t-display', styles.title)}>{title}</b>
      {children && <div className={styles.text}>{children}</div>}
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
